import DeleteIcon from '@mui/icons-material/Delete';
import {Box, IconButton, Typography, useTheme} from '@mui/material';
import Grid from '@mui/material/Grid';

import {BREAKPOINTS, SNACKBAR_ACTIONS} from '../../../../const';
import useBreakpoint from '../../../../hooks/dom/useBreakpoint';
import useMainSidebar from '../../../../hooks/providers/useMainSidebar';
import useReport from '../../../../hooks/providers/useReport';
import useReportViews from '../../../../hooks/providers/useReportViews';
import useSnackbar from '../../../../hooks/providers/useSnackbar';
import PopperComponent from '../../../main-sidebar/PopperComponent/PopperComponent';
import BaseModal from '../../../modal/BaseModal';

const ChooseViewPopper = () => {
  const theme = useTheme();
  const {selectedReport} = useReport();
  const {showSnackbar} = useSnackbar();
  const {closeAllSidebarRelatedPoppers, setIsReportAndModulesMobileDrawerOpen} = useMainSidebar();
  const {reportViews, setIsReportPristine, chooseViewPopperAnchorEl, isChooseViewPopperOpen: isOpen, setIsChooseViewPopperOpen: setOpen, setIsDeleteViewModalOpen, setViewToDelete} = useReportViews();

  const currentBreakpoint = useBreakpoint();
  const isSmallScreen = currentBreakpoint === BREAKPOINTS.xs || currentBreakpoint === BREAKPOINTS.sm;

  const userCreatedViews = reportViews.filter(view => view.is_visible);

  const onViewSelect = async selectedView => {
    setIsReportAndModulesMobileDrawerOpen(false);
    closeAllSidebarRelatedPoppers();
    await selectedReport.bookmarksManager.applyState(selectedView.report_state);

    await selectedReport.refresh();

    // This is a hack because report is shrinked after applying a bookmark state
    // We have to manually force-resize the iframe so PBI embedded content adapts to the actual window width
    const iframe = document.querySelector('iframe');
    if (iframe) {
      iframe.style.height = `${iframe.clientHeight + 1}px`;
      setTimeout(() => {
        iframe.style.height = `${iframe.clientHeight - 1}px`;
      }, 100);
    }

    setIsReportPristine(false);
    showSnackbar(SNACKBAR_ACTIONS.APPLY_VIEW_SUCCESS);
  };

  const onViewDelete = async selectedView => {
    closeAllSidebarRelatedPoppers();
    setIsDeleteViewModalOpen(true);
    setViewToDelete(selectedView);
  };

  const renderViews = () => {
    const fontSize = isSmallScreen ? 16 : 13;
    const iconSize = isSmallScreen ? 'medium' : 'small';

    return userCreatedViews.map(view => (
      <Grid
        key={view.report_state_name}
        container
        alignItems="center"
        justifyContent="space-between"
        flexWrap="nowrap"
        sx={{
          cursor: 'pointer',
          '&:hover p': {
            color: theme.palette.secondary.main
          }
        }}
        onClick={() => onViewSelect(view)}
      >
        <Typography color="text.primary" fontSize={fontSize}>
          {view.report_state_name}
        </Typography>
        <IconButton
          sx={{ml: 1}}
          aria-label="delete"
          color="error"
          onClick={e => {
            e.stopPropagation();
            onViewDelete(view);
          }}
        >
          <DeleteIcon fontSize={iconSize} />
        </IconButton>
      </Grid>
    ));
  };

  if (isSmallScreen) {
    return (
      <BaseModal
        hasTransition
        title="Choisir une vue"
        hasTitleDivider={false}
        hasCloseIcon
        onClose={() => setOpen(false)}
        open={isOpen}
        isFullScreen
        sx={{
          zIndex: 99999
        }}
      >
        <Box px={2} py={3}>
          {renderViews()}
        </Box>
      </BaseModal>
    );
  }

  return (
    <PopperComponent
      anchorEl={chooseViewPopperAnchorEl}
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      hasArrow={false}
      paperStyle={{
        ml: 4
      }}
    >
      <Box maxWidth={160}>{renderViews()}</Box>
    </PopperComponent>
  );
};

export default ChooseViewPopper;
